import React from "react";
import { PlusIconBg } from "../../assets/icons/icons";

export default function UploadGifSection({
  animatedPreviewRef,
  onUpload,
  handleImageLoad,
  animated_preview,
  isUploading,
  errorMessage,
}) {
  return (
    <div className="relative">
      {isUploading ? (
        <div className="h-[400px] w-[350px] animate-pulse rounded-md bg-gray-200" />
      ) : (
        <img
          src={`https://faceswap.cognise.art${animated_preview}`}
          alt="Gif Preview"
          className={`h-[400px] w-[350px] rounded-md transition-transform duration-300 ease-in-out group-hover:scale-105 ${
            animated_preview ? "block" : "hidden"
          }`}
          onLoad={handleImageLoad}
        />
      )}

      <div
        className={`absolute left-1/2 top-1/2 mx-auto w-fit -translate-x-1/2 -translate-y-1/2 cursor-pointer flex-col items-center rounded-2xl border border-red-900 bg-inherit px-[59px] py-[13px] ${
          animated_preview
            ? "hidden opacity-0 transition-opacity duration-300 ease-in-out group-hover:flex group-hover:opacity-100"
            : "flex opacity-100"
        } `}
        onClick={() => animatedPreviewRef.current.click()}
      >
        <div className="rounded-[6px]">
          <PlusIconBg />
        </div>
        <div className="text-nowrap text-[24px] font-medium leading-9 text-[#FA5711]">
          Upload GIF
        </div>
        <input
          type="file"
          id="animated_previewUploadInput"
          className="hidden"
          accept="image/gif"
          ref={animatedPreviewRef}
          onChange={onUpload}
          aria-label="Upload GIF"
          disabled={isUploading}
        />
        {errorMessage.animated_previewError && (
          <p className="mt-2 text-sm text-red-500">
            {errorMessage.animated_previewError}
          </p>
        )}
      </div>
    </div>
  );
}
